import React from 'react';

import { PapiDeviation } from '@wix/da-papi-types';
import {
  StandardDeviationElementPlacement,
  StandardDeviationElementPlacementMap,
} from './types';
import { useStandardDeviationElementPlacementMap } from './useStandardDeviationElementPlacementMap';

export const StandardDeviationElementPlacementContext =
  React.createContext<StandardDeviationElementPlacementMap>({
    elementGroups: {
      adoptableBuyer: {
        groupPlacement: StandardDeviationElementPlacement.NotIncluded,
        countOnBar: 0,
      },
      adoptableSeller: {
        groupPlacement: StandardDeviationElementPlacement.NotIncluded,
        countOnBar: 0,
      },
    },
    deleteDeviation: StandardDeviationElementPlacement.NotIncluded,
    editBackground: StandardDeviationElementPlacement.NotIncluded,
    editDeviation: StandardDeviationElementPlacement.NotIncluded,
    favourite: StandardDeviationElementPlacement.NotIncluded,
    fullscreen: StandardDeviationElementPlacement.NotIncluded,
    report: StandardDeviationElementPlacement.NotIncluded,
    shareCopyLink: StandardDeviationElementPlacement.NotIncluded,
    shareToPost: StandardDeviationElementPlacement.NotIncluded,
    subscribe: StandardDeviationElementPlacement.NotIncluded,
    comment: StandardDeviationElementPlacement.NotIncluded,
    commissionStatus: StandardDeviationElementPlacement.NotIncluded,
    orderCommission: StandardDeviationElementPlacement.NotIncluded,
    premiumDownload: StandardDeviationElementPlacement.NotIncluded,
    freeDownload: StandardDeviationElementPlacement.NotIncluded,
    addToGroup: StandardDeviationElementPlacement.NotIncluded,
    awardBadge: StandardDeviationElementPlacement.NotIncluded,
    boostDeviation: StandardDeviationElementPlacement.NotIncluded,
    sellDeviation: StandardDeviationElementPlacement.NotIncluded,
    privateCollection: StandardDeviationElementPlacement.NotIncluded,
    viewOrderHistory: StandardDeviationElementPlacement.NotIncluded,
    unpublish: StandardDeviationElementPlacement.NotIncluded,
    draw: StandardDeviationElementPlacement.NotIncluded,
    requestOriginal: StandardDeviationElementPlacement.NotIncluded,
    meta: {
      hasPrimaryMoreActionsMenu: false,
      hasSecondaryMoreActionsMenu: false,
    },
  });

interface ProviderProps {
  deviation: PapiDeviation;
  children: React.ReactNode;
}

export const StandardDeviationElementPlacementContextProvider: React.FC<
  ProviderProps
> = ({ deviation, children }) => {
  const elementPlacementMap =
    useStandardDeviationElementPlacementMap(deviation);
  return (
    <StandardDeviationElementPlacementContext.Provider
      value={elementPlacementMap}
    >
      {children}
    </StandardDeviationElementPlacementContext.Provider>
  );
};
StandardDeviationElementPlacementContextProvider.displayName =
  'StandardDeviationElementPlacementContextProvider';
